import React from 'react'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import Snackbar from '@mui/material/Snackbar'
import {messageReset} from 'modules/messages/actions'
import warning from 'utils/enums/messages'

const messages = {
    [warning.corruptedFile]: 'main.excel_file_corrupted',
    [warning.error]: 'app.error',
    [warning.deletedExcelTemplate]: 'sidebar.delete_template_success',
    [warning.deletedPublicTable]: 'sidebar.delete_public_table_success',
    [warning.deletedPublicForm]: 'sidebar.delete_public_form_success',
    [warning.deletedExportTemplate]: 'sidebar.delete_export_success',
    [warning.deletedSmsTemplate]: 'sidebar.delete_sms_success',
    [warning.deletedEmailTemplate]: 'sidebar.delete_email_success',
    [warning.verifyError]: 'settings.verify_error',
    [warning.userNameExists]: 'profile.user_exist',
    [warning.excelImportNoMapping]: 'main.excel_import_no_mapping',
    [warning.linkedfieldOptionsError]: 'table.linkedfield_options_error',
	[warning.duplicateRecordSuccess]: 'record.duplicated_success',
	[warning.userExists]: 'login.registration_user_exist',
	[warning.registrationError]: 'login.registration_error',
	[warning.loginError]: 'login.invalid'
}

class Message extends React.Component {
    render() {
        const { intl, message } = this.props

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onClose={this.props.messageReset}
                open={!!message}
                autoHideDuration={3000}
                message={messages[message] ? intl.formatMessage({id: messages[message]}) : ''}
            />
        )
    }
}

const mapStateToProps = ({messages}) => ({
    message: messages.message
})

export default connect(mapStateToProps, {
    messageReset
})(injectIntl(Message))
